import type { TFunction } from 'i18next'

import type { PortReference } from '@/features/resource/utils/portGroups'

/**
 * How the controller at the far end of a relation is named.
 *
 * Three states, not two, and the middle one is guaranteed: a controller name reaches the API only
 * through a metering port, so any controller contributing just control ports has a number and no
 * name. Calling that "unknown" is false — we know exactly which controller it is, and the group
 * header a few centimetres above says so. Shared rather than decided at each call site, which is
 * how one page came to describe one controller two ways at once.
 */
export function targetControllerLabel(reference: PortReference, t: TFunction<'translation'>): string {
  if (reference.targetControllerName !== null) {
    return reference.targetControllerName
  }

  if (reference.targetControllerEquipmentNumber !== null) {
    return t('resources.detail_panel.controller_group_named_by_equipment_number', {
      equipmentNumber: reference.targetControllerEquipmentNumber,
    })
  }

  return t('resources.detail_panel.controller_group_unknown')
}
